import React, {PureComponent} from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import DefaultAvatar from 'assets/forms/default-avatar.svg';

import styles from './SelectUserListItem.scss';

export default class SelectUserListItem extends PureComponent {
  static propTypes = {
    user: PropTypes.object,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.string,
  }

  static defaultProps = {

  }

  handleSelect = () => {
    const {user: {id}, onSelect, selected} = this.props;

    if (selected === id) {
      onSelect(null);

      return;
    }

    onSelect(id);
  }

  render() {
    const {user: {id, fullName, email, avatar}, selected} = this.props;

    return (
      <div
        className={classnames(styles.container, {[styles.selected]: id === selected})}
        onClick={this.handleSelect}
      >
        {avatar && <img src={avatar} alt='avatar' className={styles.avatar} />}
        {!avatar && <div style={{backgroundImage: `url(${DefaultAvatar})`}} className={styles.avatar} />}
        <div className={styles.info}>
          <span className={styles.name}>
            {fullName}
          </span>
          <div className={styles.email}>
            {email}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/controls/SelectUsersDialog/SelectUsersListItem.jsx